import retrieveDropdownAgents from 'app/shared/dropdown/sagas/retrieveDropdownAgents';

const sagaRegistry = [retrieveDropdownAgents];

export default sagaRegistry;
